import React from 'react';
import { useCurrentUser, useTranslate } from '@hooks';
import { camelCase } from 'lodash';
import { toArray } from '@dotone/react-ui-core/utils';
import { FilterBlock, FilterList, BooleanFilterBlock } from '@dotone/react-ui-core';
import {
  AffiliateFilterBlock,
  MediaCategoryFilterBlock,
  CategoryGroupFilterBlock,
  CountryFilterBlock,
  OfferFilterBlock,
} from '../filters';

const AffiliateFilterList = ({ filters, ...otherProps }) => {
  const { t, tShared } = useTranslate('affiliate', 'model');
  const { t: tCampaign } = useTranslate('campaign', 'model');
  const { currentUser } = useCurrentUser();
  // const { labels, statuses, genders, sources, mediaCategoryIds } = filters;
  const {
    genders,
    mediaCategoryIds,
    countryIds,
    categoryGroupIds,
    offerIds,
    isCustomPayout,
    sourceType,
    ids,
  } = filters;

  const translate = (nestedNs, items = []) => {
    return toArray(items).map((item) => tShared(`${nestedNs}.${camelCase(item)}`));
  };

  return (
    <FilterList {...otherProps}>
      {/* <FilterBlock label={t('label')} items={translate('label', labels)} list={false} /> */}
      {!currentUser.singleOffer && <OfferFilterBlock ids={offerIds} />}
      <MediaCategoryFilterBlock ids={mediaCategoryIds} />
      {/* <FilterBlock label={t('source')} items={translate('source', sources)} list={false} /> */}
      <CategoryGroupFilterBlock ids={categoryGroupIds} />
      {currentUser.canAccessAffiliate && <CountryFilterBlock ids={countryIds} />}
      <FilterBlock label={t('gender')} items={translate('gender', genders)} list={false} />
      <BooleanFilterBlock label={tCampaign('isCustomPayout')} items={isCustomPayout} />
      <FilterBlock
        label={t('sourceType')}
        items={sourceType && toArray(t(`affiliate:sourceType.${camelCase(sourceType)}`))}
        list={false}
      />
      {!currentUser.pro && <AffiliateFilterBlock ids={toArray(ids)} />}
    </FilterList>
  );
};

export default React.memo(AffiliateFilterList);
